import { Col } from "react-bootstrap";
import FormField from "../common/FormField";
import SelectField from "../common/SelectField";

export default function SettlementForm({
    formData,
    handleChange,
    handleSubmit,
    isSubmitting,
    formErrors,
    settlementType
}) {

    const handleKeyDown = (e) => {
        try {
            if (e?.key === "Enter" && e?.target?.type !== "textarea") {
                e?.preventDefault();
                handleSubmit(e);
            }
        } catch (error) {
            console.log(`Error: ${error}`);
        }
    };

    return (
        <div className="row g-3 mb-5 px-3">
            <div className="w-100 mb-3">
                <label className="d-block mb-1 fs-5 fw-bold text-dark">
                    Settlement & Billing <sup className="text-danger">*</sup>
                </label>
            </div>
            {/* Settlement Account Type */}
            {/* <div className="col-12 col-md-4 col-lg-4">
                <SelectField
                    label="Select Account Type"
                    name="settlementAccountType"
                    value={formData?.settlementAccountType || ""}
                    onChange={handleChange}
                    required
                    options={[{ value: "MERCHANT", label: "Merchant" }]}
                    error={formErrors?.settlementAccountType}
                />
            </div> */}

            {/* Billing Mode */}
            <div className="col-12 col-md-4 col-lg-4">
                <SelectField
                    label="Settlement / Billing Mode"
                    name="billingMode"
                    value={formData?.billingMode || ""}
                    onChange={handleChange}
                    required
                    options={[
                        { value: "POSTPAID", label: "Postpaid" },
                        { value: "INSTANT", label: "Instant", disabled: true },
                    ]}
                    error={formErrors?.billingMode}
                />
            </div>

            {/* Conditional Postpaid Fields */}
            {formData?.billingMode === "POSTPAID" && (
                <>
                    {/* Billing Cycle */}
                    <div className="col-12 col-md-4 col-lg-4">
                        <SelectField
                            label="Billing Cycle"
                            name="billingCycle"
                            value={formData?.billingCycle || ""}
                            onChange={handleChange}
                            required
                            options={[
                                { value: "daily", label: "Daily" },
                                { value: "weekly", label: "Weekly" },
                                { value: "monthly", label: "Monthly" },
                                { value: "CUSTOM", label: "Custom" },
                            ]}
                            error={formErrors?.billingCycle}
                        />
                    </div>
                    {formData?.billingCycle === "CUSTOM" && (
                        <div className="col-12 mt-0">
                            <p className="text-info small mb-2 mx-1">
                                <i className="fa fa-info-circle me-1"></i>
                                Custom ranges: 1-10, 11-20, 21-End of month. End date auto-sets based on start date.
                            </p>
                        </div>
                    )}

                    {/* Start Date */}
                    <div className="col-12 col-md-4 col-lg-4">
                        <FormField
                            label="Start Date of Billing"
                            name="startDate"
                            type="date"
                            value={formData?.startDate || ""}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            required
                            error={formErrors?.startDate}
                            min={new Date().toISOString().split("T")[0]}
                        />
                    </div>

                    {/* Billing End Date */}
                    <div className="col-12 col-md-4 col-lg-4">
                        <FormField
                            label="Billing End Date"
                            name="billingEndDate"
                            type="date"
                            value={formData?.billingEndDate || ""}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            required
                            error={formErrors?.billingEndDate}
                            readOnly={formData?.billingCycle === "CUSTOM"}
                            min={
                                formData?.startDate || new Date().toISOString().split("T")[0]
                            }
                        />
                    </div>
                </>
            )}

            {formData?.billingMode === "POSTPAID" && (
                <Col xs={12} className="mt-0">
                    <div className="d-flex justify-content-end bg">
                        <button
                            className="badge badge-rounded badge-primary mx-3 px-3 py-2"
                            id="mdrSave"
                            disabled={isSubmitting}
                            type="submit"
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </Col>
            )}
        </div>
    );
}